// Auto-generated index file for locale exports
import en from './en'
import fr from './fr'
import nl from './nl'
import de from './de'
import bg from './bg'
import hr from './hr'
import cs from './cs'
import hu from './hu'
import it from './it'
import pl from './pl'
import ro from './ro'
import sl from './sl'
import es from './es'
import tr from './tr'
import ar from './ar'
import pt from './pt'
import sk from './sk'
import th from './th'

const locales = {
  en: en,
  fr: fr,
  nl: nl,
  de: de,
  bg: bg,
  hr: hr,
  cs: cs,
  hu: hu,
  it: it,
  pl: pl,
  ro: ro,
  sl: sl,
  es: es,
  tr: tr,
  ar: ar,
  pt: pt,
  sk: sk,
  th: th
}

export default locales
